import React from 'react'
import clsx from 'clsx'

import AddColor from '../../../../../pages/Settings/Controls/Add/AddColour'

import useStyles from './styles'

const ColorInput = ({ name, className, ...props }) => {
  const classes = useStyles()

  return (
    <div className={clsx(classes.root, className)}>
      <AddColor {...props} />

      {name}
    </div>
  )
}

export default ColorInput
